<template>
  <div class="donator_step1">
   <div class="container">
   	<div class="row">
   		<div class="col-md-6 offset-md-3">
        <h3>Stap 2</h3>
   			<h1>Uw gegevens</h1>

        <div class="form-group">
            <label for="name" >Bedrag</label>
            <input type="text" class="form-control" v-model="amount" disabled>
          </div>
          <div class="form-group">
            <label for="name" >Periode</label>
            <input type="text" class="form-control" v-model="period" disabled>
          </div>


   				<div class="form-group">
   					<label for="name" >Naam</label>
   					<input type="text" name="name" id="name" placeholder="Naam" class="form-control" v-model="name">
   				</div>
   				<div class="form-group">
   					<label for="name" >Email:</label>
   					<input type="email" name="email" id="email" placeholder="Email" class="form-control" v-model="email">
   				</div>
   				<div class="form-group">
   					<label for="name" >IBAN:</label>
   					<input type="text" name="iban" id="iban" placeholder="IBAN" class="form-control" v-model="iban">
   				</div>
          <div class="form-check">
            <input type="checkbox" name="iban" id="iban" placeholder="IBAN" class="form-check-input" v-model="check">
            <label for="iban">Ja, ik machtig Stichting Vrienden van Schisisonderzoek om maandelijks geld af te schrijven. Wij zullen het ingevulde bedrag rond de 25e van de maand afschrijven.</label>
          </div>
   				<router-link :to="{ name: 'Donator_step1' }"><button>Terug</button></router-link><button v-on:click="add">Word donateur!</button>
   		</div>
   	</div>
   </div>
  </div>
</template>

<script>
export default {
  name: 'Donator_step2',
  data(){
    return {
      amount: this.$route.params.amount,
      period: this.$route.params.period,
      name: '',
      email: '',
      iban: '',
      check: ''
    }
  },
  methods: {
    add: function (event) {

      var data = {
        "title": this.name,
        "email": this.email,
        "iban": this.iban,
        "bedrag": this.amount,
        "periode": this.period
      };

      if(this.check){ 
        this.$http.post('wp/v2/donators', data).then(response => {
          this.$router.push('/donator/thankyou')
        }, error => {
          console.log(error)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/donator/Step2.vue